import { About as AboutFeature } from '../../../features/about/components/about';

const About = () => <AboutFeature />;

export { About };
